module.exports = __webpack_public_path__ + "img/logo-white.c24719ba.png";